<!--
 * @Author: qoder
 * @Description: 完成工单/添加维修备注（mode: complete | remark）
-->
<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form-container">
    <ykc-form-item label="工单编号">
      <span class="order-no-text">
        {{ (orderInfo && orderInfo.orderNo) || (batchOrderIds ? '批量操作' : '-') }}
      </span>
    </ykc-form-item>
    <ykc-form-item label="维修总结" prop="repairSummary">
      <ykc-input
        type="textarea"
        :rows="4"
        maxlength="2000"
        placeholder="请输入维修总结"
        v-model="ruleForm.repairSummary"></ykc-input>
    </ykc-form-item>
    <ykc-form-item label="维修后照片" prop="afterRepairPhotos">
      <ykc-upload
        :fileList="fileList"
        :limit="10"
        accept=".jpg,.jpeg,.png"
        @handleChange="handleUpload"
        @handleRemove="handleRemove"></ykc-upload>
    </ykc-form-item>
  </ykc-form>
</template>

<script>
  import { repairOrderApi, uploadUtils } from '@/service/apis';

  export default {
    name: 'CompleteOrRemark',
    props: {
      mode: {
        type: String,
        default: 'complete',
      },
      orderInfo: {
        type: Object,
        default: null,
      },
      batchOrderIds: {
        type: Array,
        default: null,
      },
    },
    data() {
      return {
        ruleForm: {
          repairSummary: '',
          afterRepairPhotos: [],
        },
        fileList: [],
        rules: {
          repairSummary: [{ required: true, message: '请输入维修总结', trigger: 'blur' }],
          afterRepairPhotos: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (this.ruleForm.afterRepairPhotos.length === 0) {
                  callback(new Error('请上传维修后照片'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
        },
      };
    },
    methods: {
      async submit() {
        const isBatch = this.batchOrderIds && this.batchOrderIds.length > 0;
        if (!isBatch && !this.orderInfo?.id) {
          this.$message.error('工单信息缺失');
          return false;
        }
        const valid = await new Promise(r => this.$refs.ruleForm.validate(r));
        if (!valid) return false;
        try {
          const params = {
            repairSummary: this.ruleForm.repairSummary,
            afterRepairPhotos: this.ruleForm.afterRepairPhotos,
            operatorId: localStorage.userId,
            operatorName: localStorage.accountName,
          };
          if (isBatch) {
            params.orderIds = this.batchOrderIds;
            if (this.mode === 'complete') {
              await repairOrderApi.batchComplete(params);
              this.$message.success('批量完成成功');
            } else {
              await repairOrderApi.batchAddRemark(params);
              this.$message.success('批量添加维修备注成功');
            }
          } else {
            params.orderId = this.orderInfo.id;
            if (this.mode === 'complete') {
              await repairOrderApi.complete(params);
              this.$message.success('工单已完成');
            } else {
              await repairOrderApi.addRemark(params);
              this.$message.success('维修备注添加成功');
            }
          }
          this.$emit('success');
          return true;
        } catch (error) {
          console.error('提交失败', error);
          this.$message.error(error?.message || '提交失败');
          return false;
        }
      },
      handleUpload(file, fileList, isCheck) {
        if (!isCheck) return;
        const formData = new FormData();
        formData.append('file', file.raw);
        formData.append('bizName', 'poly/repair');
        uploadUtils
          .uploadImg(formData)
          .then(res => {
            const ossUrl = res;
            const target = this.fileList.find(f => f.uid === file.uid);
            if (target) {
              target.url = ossUrl;
              target.ossUrl = ossUrl;
            } else {
              this.fileList.push({ ...file, url: ossUrl, ossUrl });
            }
            this.ruleForm.afterRepairPhotos = this.fileList.map(f => f.ossUrl || f.url);
            // 上传成功后主动校验该字段，清除可能残留的错误提示
            this.$refs.ruleForm?.validateField('afterRepairPhotos');
          })
          .catch(err => {
            console.error('上传图片失败', err);
            this.$message.error('上传图片失败，请重试');
            this.fileList = this.fileList.filter(f => f.uid !== file.uid);
            this.ruleForm.afterRepairPhotos = this.fileList.map(f => f.ossUrl || f.url);
          });
      },
      handleRemove(file) {
        this.fileList = this.fileList.filter(f => f.uid !== file.uid);
        this.ruleForm.afterRepairPhotos = this.fileList.map(f => f.ossUrl || f.url);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-container {
    padding: 20px;
  }
  .order-no-text {
    font-weight: 500;
    color: #1e293b;
  }
</style>
